import { render } from "./PanelAgendaPanelistCreate.vue?vue&type=template&id=94f95184"
import script from "./PanelAgendaPanelistCreate.vue?vue&type=script&lang=js"
export * from "./PanelAgendaPanelistCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__